import { lazy } from 'react';

export default [
    {
        path: '/temple-exhibition-matterport',
        exact: true,
        component: lazy(() => import(/* webpackChunkName: 'TempleExhibitionLayout' */ './layout')),
    },
];
